export default __webpack_public_path__ + "static/media/iconesDocumentos.6aeb7bd6.png";